module.exports = __webpack_public_path__ + "img/llavero2.5a0c6545.png";